/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
/* eslint-disable indent */
// Libraries
import { FormElems, Alert } from '../';
import {
    updateIntentRequest,
    updateIntentError,
} from '../../containers/RoleVerification/redux/roleVerification.actions';
import { VERIFICATION_MESSAGE } from '../../utils/constants/toastMessages';
import { INPROCESS } from '../../components/Table/table.constants';
import { getPermissionsOptions, getIntent } from '../../utils/helperMethods';
import validate from './validator';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import { camelCase, isEmpty, startCase } from 'lodash';

// Components

// Actions

// Helper Methods

// Validator

// Styles
import './roleVerificationForm.scss';

const RoleVerificationForm = props => {
    const {
        actions,
        handleSubmit,
        closePopup,
        data,
        roleStatus,
        roleVerificationData,
    } = props;
    const { updateIntent } = roleVerificationData;

    const isInProcess = roleStatus === INPROCESS;

    useEffect(() => {
        if (updateIntent.isSuccess) {
            closePopup(true);
            toast.info(VERIFICATION_MESSAGE.ROLE_STATUS_UPDATE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateIntent.isSuccess]);

    useEffect(() => {
        return () => {
            actions.updateIntentError({ error: {}, isSuccess: false });
        };
    }, [actions]);

    const handleFormSubmit = values => {
        if (values.userAction === 'approve') {
            actions.updateIntentRequest({
                requestId: data.requestId,
                comment: values.comment,
                action: 'APPROVED',
            });
        }

        if (values.userAction === 'reject') {
            actions.updateIntentRequest({
                requestId: data.requestId,
                comment: values.comment,
                action: 'REJECTED',
            });
        }
    };

    return (
        <form className="role-verification-view">
            <div className="form-section">
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <div className="lastupdate-status">
                        {data.roleCreatedUpdate && (
                            <>
                                {getIntent(data.lastActions)}{' '}
                                <strong>{data.roleCreatedUpdate}</strong>,{' '}
                                {moment(data.roleCreatedDate, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.roleCreatedDate, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.roleCreatedDate}
                            </>
                        )}
                    </div>
                    <div className={`status ${data.roleStatusNew}`}>
                        <span className="text-simple">
                            {data.roleStatusNew}
                        </span>
                        {data.roleStatusOld &&
                        data.roleStatusOld !== data.roleStatusNew ? (
                            <span className="strike-through">
                                {data.roleStatusOld}
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="management-section">
                {data.resourceDetail.map((resource, index) => {
                    return (
                        <div className="resource-container">
                            <div className="form-section">
                                <p className="label">
                                    {resource.labelName ||
                                        startCase(
                                            camelCase(resource.resourceName)
                                        )}
                                </p>
                                <div className="permission-form-section">
                                    {resource.permissionDetail.map(
                                        permission => {
                                            return (
                                                <>
                                                    <div className="permission-detail">
                                                        <span className="custom-icon"></span>
                                                        {permission.labelName ||
                                                            startCase(
                                                                camelCase(
                                                                    permission.permissionName
                                                                )
                                                            )}
                                                    </div>
                                                    {permission?.subPermissionDetails?.map(
                                                        subPermission => {
                                                            return (
                                                                <div className="permission-detail sub-permission-detail">
                                                                    <span className="custom-icon"></span>
                                                                    {subPermission.labelName ||
                                                                        startCase(
                                                                            camelCase(
                                                                                subPermission.permissionName
                                                                            )
                                                                        )}
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="form-section comment-box">
                <p className="label">Comment</p>
                {data.checkerComment
                    ? data.checkerComment
                    : data.makerComment || '-'}
            </div>
            {isInProcess ? (
                <div className="form-section comment-box borderless">
                    <p className="label">Comment</p>
                    <Field
                        wrapperClass="comment-input"
                        name="comment"
                        type="textarea"
                        component={FormElems.TextArea}
                        placeholder="Enter Comment "
                    />
                </div>
            ) : null}
            {updateIntent.error && updateIntent.error.errorMessage ? (
                <Alert>{updateIntent.error.errorMessage}</Alert>
            ) : null}
            <div className="form-section action">
                {isInProcess ? (
                    <>
                        <FormElems.Button
                            buttonType="secondary"
                            text="REJECT"
                            customClass="cancel-button"
                            type="button"
                            handleClick={handleSubmit(values => {
                                handleFormSubmit({
                                    ...values,
                                    userAction: 'reject',
                                });
                            })}
                        />
                        <FormElems.Button
                            buttonType="primary"
                            text="APPROVE"
                            type="button"
                            handleClick={handleSubmit(values => {
                                handleFormSubmit({
                                    ...values,
                                    userAction: 'approve',
                                });
                            })}
                        />
                    </>
                ) : null}
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, roleVerificationData, form }) => ({
    auth,
    roleVerificationData,
    formData: form['role-verification'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updateIntentRequest,
            updateIntentError,
        },
        dispatch
    ),
});

RoleVerificationForm.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    roleStatus: PropTypes.string,
    roleVerificationData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'role-verification',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(RoleVerificationForm);
